import { observer } from 'mobx-react-lite'
import { CampaignStatusConfig } from 'entities/Campaign/ui/CampaignStatus'
import type { IResponseCampaignStatus } from 'entities/Campaign'
import type { IFilterValue, IWidgetProps } from 'widgets/FilterEditor/types/types'
import { WidgetStatus } from 'widgets/FilterEditor/ui/Widget/WidgetStatus'

export const WidgetCampaignStatus = observer(
  (props: IWidgetProps<IFilterValue<IResponseCampaignStatus>, IResponseCampaignStatus[]>) => {
    return <WidgetStatus getConfigByStatus={(status) => CampaignStatusConfig[status]} {...props} />
  }
)
